import { Injectable } from '@angular/core';
import { RouterStateSerializer } from '@ngrx/router-store';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { SerializedRouterState } from '@ps/core-data-access';

/**
 * Minimal router state stored inside NgRx.
 *
 * The default NgRx router-store keeps the entire Angular
 * router tree in the store which can be large and noisy
 * in Redux DevTools.
 *
 * This serializer keeps only the most useful information.
 * SerializedRouterState is defined in @ps/data-access so
 * RouterFacade can build typed selectors against it.
 */
@Injectable()
export class RouterStoreSerializer
  implements RouterStateSerializer<SerializedRouterState>
{
  public serialize(routerState: RouterStateSnapshot): SerializedRouterState {
    let route: ActivatedRouteSnapshot = routerState.root;

    /* Traverse the router tree to get the deepest active route.
     Route-specific information like `params` and `data` usually belong
     to the last matched route (e.g., `/users/:id` → params come from `:id`).
     */

    while (route.firstChild) {
      route = route.firstChild;
    }

    const { url, root } = routerState;

    return {
      url,
      params: route.params ?? {}, // Params are extracted from the deepest active route
      queryParams: root.queryParams ?? {}, // Query params are extracted from the root
      fragment: root.fragment ?? null, // Fragment is extracted from the root
      data: route.data ?? {}, // Route-specific metadata defined in route config
    };
  }
}
